import { ObjectTypes } from '@playbooks/core/src/interfaces/ConnectToCrmWidget'
import { useTranslation } from '../contexts/localization/Localization'

function getCrmObjectName(objectType: ObjectTypes) {
  const { text } = useTranslation
  switch (objectType) {
    case ObjectTypes.company:
      return text('company')
    case ObjectTypes.deal:
      return text('opportunity')
    default:
      return text('contact')
  }
}

export default getCrmObjectName
